import { CombinedTextProps } from '@dtx-company/shared-components/src'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import styled from 'styled-components'

export const StyledText: React.ComponentType<
  CombinedTextProps & { invertColor?: boolean }
> = styled(Text)<{ invertColor?: boolean }>`
  color: ${({ invertColor, theme }) =>
    invertColor ? theme.colors.primary.white : theme.colors.primary.black};
`

export const StyledLinkText: React.ComponentType<
  CombinedTextProps & { invertColor?: boolean }
> = styled(Text)<{ invertColor?: boolean }>`
  color: ${({ invertColor, theme }) =>
    invertColor ? theme.colors.primary.skyBlue : theme.colors.primary.flowBlue};
`
